export const getMenuData = [
  {
    title: 'Dashboard',
    lang: 'dashboard',
    key: 'dashboard',
    icon: 'fe fe-home',
    url: '/dashboard',
    roles: ['distributor', 'dropship'],
  },
  {
    title: 'Sales',
    lang: 'sales',
    key: 'sales',
    icon: 'fe fe-database',
    roles: ['distributor', 'dropship'],
    children: [
      {
        title: 'Order List',
        lang: 'orderList',
        key: 'order-list',
        url: '/sales',
        roles: ['distributor', 'dropship'],
      },
      {
        title: 'Commission List',
        lang: 'commissionList',
        key: 'list-commission',
        url: '/account/list-commission',
        roles: ['dropship'],
      },
    ],
  },
  {
    title: 'Purchase Order',
    key: 'purchase',
    lang: 'purchase',
    icon: 'fe fe-shopping-cart',
    roles: ['distributor'],
    children: [
      {
        title: 'Catalogue',
        key: 'catalogue',
        lang: 'purchaseCatalogue',
        url: '/purchase/catalogue',
        roles: ['distributor'],
      },
      {
        title: 'Purchase List',
        key: 'purchaseList',
        lang: 'purchaseList',
        url: '/purchase',
        roles: ['distributor'],
      },
      {
        title: 'Create Purchase',
        key: 'createPurchase',
        lang: 'createPurchase',
        url: '/purchase/add',
        roles: ['distributor'],
      },
    ],
  },
  {
    title: 'Store',
    lang: 'store',
    key: 'store',
    icon: 'fe fe-shopping-bag',
    roles: ['dropship', 'distributor'],
    children: [
      {
        title: 'Available Products',
        lang: 'availableProducts',
        key: 'product-list',
        url: '/store/available-products',
        roles: ['dropship'],
      },
      {
        title: 'My Products',
        lang: 'myProducts',
        key: 'product-in-store',
        url: '/store/my-products',
        roles: ['dropship', 'distributor'],
      },
      {
        title: 'Setting',
        lang: 'setting',
        key: 'setting',
        url: '/store/store-settings',
        roles: ['dropship', 'distributor'],
      },
      {
        title: 'View Store',
        lang: 'viewStore',
        key: 'my-store',
        url: 'store_url',
        roles: ['dropship', 'distributor'],
      },
    ],
  },
  {
    title: 'Account',
    lang: 'account',
    key: 'account',
    icon: 'fe fe-user-plus',
    roles: ['distributor', 'dropship'],
    children: [
      {
        title: 'Edit Profile',
        lang: 'editProfile',
        key: 'edit-profile',
        url: '/account/edit-profile',
        roles: ['distributor', 'dropship'],
      },
      {
        title: 'E-wallet History',
        lang: 'ewalletHistory',
        key: 'ewallet-history',
        url: '/account/ewallet',
        roles: ['distributor', 'dropship'],
      },
      {
        title: 'Withdraw Request',
        lang: 'withdrawRequest',
        key: 'withdraw-request',
        url: '/account/withdraw-request',
        roles: ['distributor', 'dropship'],
      },
    ],
  },
]
